(() => {
  // ====== CONFIG ======
  const THRESHOLD = 4;               // 4 jars to reach the deal
  const JAR_TAG = 'jar';             // product tag used to identify jar products
  const AUTO_HIDE_MS = 4000;

  // Message template
    const buildMessage = (remaining) => {
    if (remaining <= 0) return "Nice — you’ve reached the 4-jar deal!";
    if (remaining === 1) return "Only 1 more jar until you get one free!";
    return `Only ${remaining} more jars until you get one free!`;
    };

  // ====== DOM ======
  const snackbar = document.getElementById('pickleBundleSnackbar');
  const snackbarText = document.getElementById('pickleBundleSnackbarText');
  if (!snackbar || !snackbarText) return;

  const closeBtn = snackbar.querySelector('.pickle-bundle-snackbar__close');

  let hideTimer = null;

  function showSnackbar(message) {
    snackbarText.textContent = message;
    snackbar.hidden = false;

    // animate in (if enabled)
    snackbar.classList.add('pickle-bundle-snackbar--show');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideSnackbar, AUTO_HIDE_MS);
  }

  function hideSnackbar() {
    clearTimeout(hideTimer);
    snackbar.classList.remove('pickle-bundle-snackbar--show');

    // allow transition to complete
    setTimeout(() => {
      snackbar.hidden = true;
    }, 200);
  }

  closeBtn?.addEventListener('click', hideSnackbar);

  // ====== CART HELPERS ======
//   async function fetchCart() {
//     const res = await fetch('/cart.js', { credentials: 'same-origin' });
//     if (!res.ok) throw new Error('Failed to fetch cart');
//     return res.json();
//   }
  async function fetchCart() {
    const res = await fetch(`/cart.js?ts=${Date.now()}`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json' },
    });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  function countEligibleJars(cart) {
    // cart.items include product info, including tags (in most themes)
    // If tags are missing in your cart response, see note below for fallback.
    let jarCount = 0;

    
    for (const item of cart.items || []) {
      const tags = (item.product_has_only_default_variant === undefined && item.tags)
        ? item.tags
        : item.product?.tags; // defensive if theme/polyfill changes structure

      const tagList = Array.isArray(tags)
        ? tags
        : (typeof tags === 'string' ? tags.split(',').map(s => s.trim()) : []);

      const isJar = item.variant_options?.includes('Quart') || item.variant_options?.includes('Chips') || item.variant_options?.includes('Whole')
      if (!isJar) continue;

      jarCount += Number(item.quantity || 0);
    }

    return jarCount;
  }

//   async function updateAndMaybeShow() {
//     const cart = await fetchCart();
//     const jarCount = countEligibleJars(cart);
//     // Only show up until the customer reaches 4 jars
//     if (jarCount >= THRESHOLD) {
//       // Optional: you can show the success message once, or hide immediately:
//       showSnackbar(buildMessage(0));
//       return;
//     }

//     const remaining = THRESHOLD - jarCount;
//     showSnackbar(buildMessage(remaining));
//   }

    async function updateAndMaybeShow(cartOverride) {
    const cart = cartOverride || await fetchCart();
    const jarCount = countEligibleJars(cart);

    if (jarCount >= THRESHOLD) {
        showSnackbar(buildMessage(0));
        return;
    }

    const remaining = THRESHOLD - jarCount;
    showSnackbar(buildMessage(remaining));
    if (isCartPage && cartModalText) {
      cartModalText.textContent = buildMessage(remaining <= 0 ? 0 : remaining);
    }
    }

  // ====== CART MODAL DOM (cart page only) ======
  const isCartPage = (window.location.pathname.replace(/\/$/, '') === '/cart');

  const cartModal = document.getElementById('pickleBundleCartModal');
  const cartModalText = document.getElementById('pickleBundleCartModalText');

  function openCartModal(message) {
    if (!cartModal || !cartModalText) return;
    cartModalText.textContent = message;
    cartModal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeCartModal() {
    if (!cartModal) return;
    cartModal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  if (cartModal) {
    cartModal.querySelector('.pickle-bundle-cart-modal__close')?.addEventListener('click', closeCartModal);
    cartModal.querySelector('.pickle-bundle-cart-modal__ok')?.addEventListener('click', closeCartModal);
    cartModal.querySelector('.pickle-bundle-cart-modal__overlay')?.addEventListener('click', closeCartModal);
    document.addEventListener('keydown', (e) => {
      if (!cartModal.hidden && e.key === 'Escape') closeCartModal();
    });
  }


  async function waitForCartChange(prevItemCount, { timeoutMs = 2500, intervalMs = 120 } = {}) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
        const cart = await fetchCart();
        if ((cart?.item_count ?? 0) !== prevItemCount) return cart;
        await new Promise(r => setTimeout(r, intervalMs));
    }
    // last attempt
    return fetchCart();
    }

  // ====== DETECT ADD-TO-CART ======
  // 1) Catch native form submissions for product forms (Dawn uses these)
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;

  const action = (form.getAttribute('action') || '').toLowerCase();
  if (!action.includes('/cart/add')) return;

  try {
    const prevCart = await fetchCart();
    const prevItemCount = prevCart?.item_count ?? 0;

    // Let theme do its normal add-to-cart behavior.
    // Wait for the network + cart to actually reflect the change.
    setTimeout(async () => {
      try {
        const updatedCart = await waitForCartChange(prevItemCount);
        await updateAndMaybeShow(updatedCart);
      } catch (_) {}
    }, 50);
  } catch (_) {
    // fallback
    setTimeout(() => updateAndMaybeShow().catch(() => {}), 500);
  }
}, true);


  // 2) Also react to AJAX cart events some themes emit
  // Dawn dispatches "cart:updated" / "cart:refresh" in some customizations,
  // and Shopify sections sometimes trigger "cart:change" patterns.
  window.addEventListener('cart:updated', () => updateAndMaybeShow().catch(() => {}));
  window.addEventListener('cart:refresh', () => updateAndMaybeShow().catch(() => {}));
  window.addEventListener('cart:change', () => updateAndMaybeShow().catch(() => {}));

  // Optional: If you want it to show when cart changes from anywhere (quantity buttons etc)
  // you can also listen to "change" events on cart drawer inputs and call update.

  // ====== Show cart modal on cart page load ======
  if (isCartPage && cartModal && cartModalText) {
    // Optional: don't show repeatedly
    const dismissKey = 'pickle_bundle_cart_modal_dismissed_at';
    const DISMISS_TTL_MS = 1000 * 60 * 60; // 1 hour

    const wasDismissedRecently = () => {
      const t = Number(localStorage.getItem(dismissKey) || '0');
      return t && (Date.now() - t) < DISMISS_TTL_MS;
    };

    const markDismissed = () => localStorage.setItem(dismissKey, String(Date.now()));

    // Override close to also set dismissal
    const originalClose = closeCartModal;
    const closeAndDismiss = () => { originalClose(); markDismissed(); };

    cartModal.querySelector('.pickle-bundle-cart-modal__close')?.addEventListener('click', closeAndDismiss);
    cartModal.querySelector('.pickle-bundle-cart-modal__ok')?.addEventListener('click', closeAndDismiss);
    cartModal.querySelector('.pickle-bundle-cart-modal__overlay')?.addEventListener('click', closeAndDismiss);

    (async () => {
      try {
        const cart = await fetchCart();
        const jarCount = countEligibleJars(cart);
        const remaining = THRESHOLD - jarCount;

        if (!wasDismissedRecently()) {
          openCartModal(buildMessage(remaining));
        } else {
          // Keep text updated even if not opening
          cartModalText.textContent = buildMessage(remaining);
        }
      } catch (_) {}
    })();
  }

})();
